import api from 'shared/api';

export const fetchCustomFields = (licenseId) => {
  const url = `/api/v1/license-custom-fields/?license=${licenseId}`;
  return api.get(url);
};

export const createLicenseCustomField = (payload) => {
  const url = `/api/v1/license-custom-fields/`;
  return api.post(url, payload);
};

export const updateLicenseCustomField = (licenseCustomFieldId, payload) => {
  const url = `/api/v1/license-custom-fields/${licenseCustomFieldId}/`;
  return api.patch(url, payload);
};

export const deleteLicenseCustomField = (licenseCustomFieldId) => {
  const url = `/api/v1/license-custom-fields/${licenseCustomFieldId}/`;
  return api.delete(url);
};
